module.exports = __webpack_public_path__ + "img/dieselConsumption.88ab16c5.svg";